import React from 'react';
import { FolderSymlinkFill } from 'react-bootstrap-icons';

export const CalendarLegend: React.FC = () => {
  return (
    <div className="calendar-legend">
      <small className="calendar-legend-content">
        <span className="calendar-legend-title">
          <strong>Legenda:</strong>
        </span>
        <span className="calendar-legend-item calendar-legend-item-planned">
          🔵 Zaplanowana wizyta
        </span>
        <span className="calendar-legend-item calendar-legend-item-finished">
          ✅ Utworzone badanie
        </span>
        <span className="calendar-legend-text">
          <FolderSymlinkFill className="mx-2 icon-blue" size={16} /> = Zapisy
          zewnętrzne
        </span>
        <span className="calendar-legend-text">💰 = Rozpoczęto płatność</span>
      </small>
    </div>
  );
};
